import styled from "styled-components";
import Variables from "../../assets/styleVariables";
export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  .highlight {
    color: ${Variables.colors.primary_vivid};
    font-weight: ${Variables.font_weight.medium};
  }
`;
export const Input = styled.input`
  height: 40px;
  position: relative;
  border: none;
  border-bottom: 2px solid rgba(0, 0, 0, 0);
  padding: 0 8px 0 58px;
  width: 100% !important;
  border-radius: 4px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  ${props =>
    props.value
      ? `background-color: ${Variables.colors.complementary_200};`
      : ""}
  &:hover {
    background-color: ${Variables.colors.complementary_200};
  }
  &::placeholder {
    color: ${Variables.colors.complementary_700};
    font-size: ${Variables.font_sizes.x_medium};
  }
  &:focus {
    border-bottom-color: ${Variables.colors.primary_vivid};
    background-color: ${Variables.colors.complementary_250};
    border-radius: 4px 4px 0 0;
  }
`;
export const IconContainer = styled.div`
  display: flex;
  position: absolute;
  height: 40px;
  align-items: center;
  left: 5%;
  padding-left: 8px;
  max-width: 56px;
  i {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.3s all;
    font-size: 10px !important;
    &::before {
      color: ${Variables.colors.complementary_800};
      margin-left: 0;
    }
    &:hover {
      background-color: ${Variables.colors.complementary_450};
    }
  }
  .expand-icon {
    ${props =>
      !props.status
        ? `
      transform: rotate(180deg);
      `
        : ""}
  }
`;
export const Notice = styled.div`
  position: absolute;
  right: 0;
  top: 40px;
  font-size: ${Variables.font_sizes.x_small};
  color: ${Variables.colors.red_600};
`;
export const ListContainer = styled.div`
  display: ${props => (props.status ? "block" : "none")};
  width: 100%;
  box-shadow: 0 2px 14px 0 #cccccc;
  height: auto;
  max-height: 230px;
  background-color: ${Variables.colors.complementary};
  border-radius: 2px;
  position: absolute;
  z-index: 99999;
  ${props => (props.listPosition !== "top" ? `top:47px;` : "bottom:47px;")}
  .loading {
    display: ${props => (props.loading === "true" ? "flex" : "none")};
    position: absolute;
    min-height: 50px;
    background-color: #fff;
    top: -1px;
    height: 100%;
    width: 100%;
    align-items: center;
    border-radius: 2px;
  }
`;
export const List = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  max-height: 190px;
  overflow-y: scroll;
  li {
    padding: 4px 16px;
    height: 42px;
    cursor: pointer;
    overflow-wrap: break-word;
    &:hover {
      background-color: ${Variables.colors.primary_50};
    }
    .label {
      color: ${Variables.colors.complementary_600};
      font-size: ${Variables.font_sizes.small};
      min-height: 10px;
      display: block;
    }
    .value {
      color: ${Variables.colors.complementary_900};
      font-size: ${Variables.font_sizes.medium};
    }
    .favorite {
      float: left;
      margin-top: -5px;
      i {
        color: gold;
        font-size: 16px !important;
        padding: 5px;
        border-radius: 50%;
        &:hover {
          color: ${Variables.colors.complementary_600};
        }
      }
    }
    .not-favorite {
      float: left;
      margin-top: -5px;
      i {
        color: ${Variables.colors.complementary_600};
        font-size: 16px !important;
        padding: 5px;
        border-radius: 50%;
        &:hover {
          color: gold;
        }
      }
    }
    .fav-loading {
      float: left;
      cursor: progress;
      margin-left: 4px;
    }
  }
`;
export const AddButton = styled.div`
  height: 40px;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-right: 9px;
  color: ${Variables.colors.complementary_900};
  font-size: ${Variables.font_sizes.medium};
  background-color: ${Variables.colors.complementary_200};
  cursor: pointer;
  border-top: ${props =>
    props.borderTop
      ? `1px solid ${Variables.colors.complementary_300}`
      : "none"};
  i {
    width: 24px;
    height: 24px;
    margin-left: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    &:before {
      margin-left: 0;
      font-size: 16px;
      color: ${Variables.colors.primary_vivid};
    }
  }
  span {
    font-weight: ${Variables.font_weight.medium};
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
